import form from './form';
import register from './register';
import pages from "./pages";
import apps_sidebar from './apps_sidebar';
import components from './components';

export default {
    form,
    register,
    "offline_mode": {
        "online": "Je bent weer online.",
        "offline": "We kunnen uw internetverbinding niet meer detecteren.",
        "banner": {
        "text": "Attentie, uw internetverbinding lijkt een probleem te hebben."
        }
    },
    "pagination": {
        "prev": "<",
        "next": ">"
    },
    "table": {
        "empty": "Geen informatie op dit moment."
    },
    "misc": {
        "confirm_page_leave": "Weet u zeker dat u deze pagina wilt verlaten? Uw wijzigingen zullen verloren gaan.",
        "confirm": "Weet je zeker dat je door wilt gaan?",
        "back_button": "Terug",
        "date_time": "Op {date} om {time}"
    },
    apps_sidebar: {
        account: 'My account',
        help: 'Help'
    },
    help_submenu: {
        label: 'Help',
        help: {
            link: 'https://pro.trustup.be/aide',
            text: "Helpcentrum",
        },
        support: {
            link: 'https://pro.trustup.be/support/',
            text: "Contact ondersteuning",
        },
        chat: {
            text: "Chat",
        }
    },
    components,
    pages,
    apps_sidebar
}